import {
	AuthenticatedUser,
	GetProjectsParams,
} from '../types/authenticationContext.types';
import { UserProject } from '../types/project.types';
import { CompanySettings } from '../types/settings';
import { createAction } from '@reduxjs/toolkit';

export const setIsInitializing = createAction<boolean>(
	'authentication/setIsInitializing',
);

export const setIsAuthenticated = createAction<boolean>(
	'authentication/setIsAuthenticated',
);

export const setUser = createAction<AuthenticatedUser>('user/profile/set');

export const setToken = createAction<string>('setToken');

export const removeToken = createAction('removeToken');

export const setDefaultSite =
	createAction<string | undefined>('setDefaultSite');

export const setDefaultSiteName = createAction<string>('setDefaultSiteName');

export const getProjects = createAction<GetProjectsParams>('projects/get');
export const getProjectsResolved = createAction<{
	list: UserProject[];
	cursor: string | null;
}>('projects/get/resolved');
export const getProjectsRejected = createAction<object>(
	'projects/get/rejected',
);
// For fetching a single project by sourceId
export const getProjectBySourceId = createAction<string>(
	'projects/getBySourceId',
);
export const getProjectBySourceIdResolved = createAction<UserProject>(
	'projects/getBySourceId/resolved',
);
export const getProjectBySourceIdRejected = createAction<object>(
	'projects/getBySourceId/rejected',
);
/**
 * Fires on hitting the project injection URL. Meant to give some of the
 * reducers a head start with some caching
 */
export const injectProject = createAction<UserProject>('project/inject');

/**
 * Sets but does not switch user context to project
 */
export const setProject = createAction<string>('project/set');
/**
 * Sets and switches user context to project
 */
export const switchProject = createAction<string>('project/switch');

export const getCompanies =
	createAction<{ initializing: boolean }>('companies/get');
export const getCompaniesResolved = createAction<CompanySettings[]>(
	'companies/get/resolved',
);
export const getCompaniesRejected = createAction<object>(
	'companies/get/rejected',
);

//type was Auth0Client before, check what suits better since is still used for forge
export const setLogoutFunction =
	createAction<{
		(o?: unknown, client?: object): void;
	}>('setLogoutFunction');
